import { render, staticRenderFns } from "./RankingCriteriaGrid.vue?vue&type=template&id=0ca5d784"
import script from "./RankingCriteriaGrid.vue?vue&type=script&lang=js"
export * from "./RankingCriteriaGrid.vue?vue&type=script&lang=js"
import style0 from "./RankingCriteriaGrid.vue?vue&type=style&index=0&id=0ca5d784&prod&lang=css"
import style1 from "./RankingCriteriaGrid.vue?vue&type=style&index=1&id=0ca5d784&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports